import { Navigate } from 'react-router'
import { useAuth } from '../lib/auth.js'
import { Spinner } from '../components/ui/index.js'
import { HeroSection } from './landing/HeroSection.js'
import { FeaturesSection } from './landing/FeaturesSection.js'
import { PreviewSection } from './landing/PreviewSection.js'
import { PricingSection } from './landing/PricingSection.js'
import { LandingFooter } from './landing/LandingFooter.js'
import styles from './Landing.module.css'

export function Landing() {
  const { login, isAuthenticated, isLoading } = useAuth()

  if (isLoading) return (
    <div className={styles.loading}>
      <Spinner size="lg" />
    </div>
  )

  if (isAuthenticated) return <Navigate to="/studio" />

  return (
    <div className={styles.page}>
      <HeroSection onLogin={login} />
      <FeaturesSection />
      <PreviewSection />
      <PricingSection onLogin={login} />
      <LandingFooter />
    </div>
  )
}
